import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SharedModule } from "src/app/shared/shared.module";
import { ProjectsComponent } from "./projects.component";
import { ProjectsListComponent } from './pages/projects-list/projects-list.component';
import { ProjectsRoutingModule } from "./projects-routing.module";
import { NgxPaginationModule } from "ngx-pagination";
import { ProjectDetailsComponent } from './pages/project-details/project-details.component';
import { NgSelectModule } from "@ng-select/ng-select";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatIconModule } from "@angular/material/icon";
import {
    DateAdapter,
    MAT_DATE_FORMATS,
    MAT_DATE_LOCALE,
  } from '@angular/material/core';
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { ProjectsOrdersComponent } from './pages/projects-orders/projects-orders.component';
import { OrderStatusMenuComponent } from "src/app/shared/components/order-status-menu/order-status-menu.component";
import { EvaluationListComponent } from './pages/evaluation-list/evaluation-list.component';
import { EvaluationDetailsComponent } from './pages/evaluation-details/evaluation-details.component';
import { EvaluationTermsComponent } from './components/evaluation-terms/evaluation-terms.component';
import { MatExpansionModule } from "@angular/material/expansion";
import { NgxSummernoteModule } from "ngx-summernote";

import { CustomDateAdapter } from "src/app/core/services/uitls/custom-date.util";
import { MATERIAL_DATEPICKER_FORMATS } from "src/app/shared/global/date-formate-constant";
@NgModule({
    declarations: [
        ProjectsComponent,
        ProjectsListComponent,
        ProjectDetailsComponent,
        ProjectsOrdersComponent,
        EvaluationListComponent,
        EvaluationDetailsComponent,
        EvaluationTermsComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        MatExpansionModule,
        NgSelectModule,
        MatInputModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatIconModule,
        ProjectsRoutingModule,
        OrderStatusMenuComponent,
        NgxSummernoteModule,
    ],
    providers: [
        DatePipe,
        {
            provide: DateAdapter,
            useClass: CustomDateAdapter,
            deps: [MAT_DATE_LOCALE],
        },
        { provide: MAT_DATE_FORMATS, useValue: MATERIAL_DATEPICKER_FORMATS },
        { provide: MAT_DATE_LOCALE, useValue: 'en-eg' },
    ]
})
export class ProjectsModule { }
